import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { authMobileReducer as authReducer } from './authMobileReducer';
import { sharedRelayVariablesReducer } from './sharedRelayVariablesReducer';
import { sharedIntlVariablesReducer } from './sharedIntlVariablesReducer';
import { filterReducer } from './filterReducer';
import { displayPreferenceReducer } from './displayPreferenceReducer';
import { measurementUnitReducer } from './measurementUnitReducer';
import dblReducers from 'dibs-buyer-layout/src/reducers';

/**
 * Local `app-buyer-finding` reducers that should be used across the app.
 */
export const defaultReducers = {
    authReducer,
    relayVariables: sharedRelayVariablesReducer,
    intlVariables: sharedIntlVariablesReducer,
};

export const sbSharedReducers = {
    filters: filterReducer,
    displayPreferences: displayPreferenceReducer,
    measurementUnit: measurementUnitReducer,
};

/**
 * Creates a redux store and applys additional middleware. Defaults to creating a store with all reducers.
 *
 * Shouldn't be used on responsive entry files!!! The store there is coming from the DBL.
 */
export function createReduxStore(additionalReducers = {}, state = {}) {
    const reducers = combineReducers({ ...defaultReducers, ...dblReducers, ...additionalReducers });
    return createStore(reducers, state, applyMiddleware(thunk));
}
